import styled from "styled-components";

export const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 640px;
  font-family: "Geist", sans-serif;
  color: #181d27;

  .setting-row {
    padding: 18px 0 20px;
    border-bottom: 0.909px solid rgba(0, 0, 0, 0.06);
  }

  .setting-row.first {
    padding-top: 10px;
  }

  .row-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
  }

  .row-text {
    flex: 1;
    min-width: 0;
  }

  .label {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.1px;
    color: #181d27;
  }

  .hint {
    margin: 2px 0 0;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.1px;
    color: #535861;
    text-wrap: pretty;
  }

  .hint.muted {
    color: #a3a7ae;
  }

  .box {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;
    padding: 16px;
    border: 0.909px solid rgba(0, 0, 0, 0.09);
    border-radius: 12px;
    background: #fafafa;
  }

  .box-text {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.1px;
    color: #414651;
  }

  .code-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
  }

  .code-row input {
    width: 140px;
    height: 40px;
    padding: 0 12px;
    border: 0.909px solid rgba(0, 0, 0, 0.09);
    border-radius: 8px;
    background: #fff;
    font-family: "Geist", sans-serif;
    font-size: 14px;
    letter-spacing: -0.1px;
  }

  .code-row input:focus {
    outline: none;
    border-color: #181d27;
  }

  @media (max-width: 768px) {
    .row-main {
      gap: 16px;
    }
  }
`;

export const Toggle = styled.button`
  position: relative;
  flex-shrink: 0;
  width: 44px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 9999px;
  background: ${({ $on }) => ($on ? "#181d27" : "#f5f5f5")};
  cursor: pointer;
  transition: background 0.15s ease;

  &::after {
    content: "";
    position: absolute;
    top: 2px;
    left: ${({ $on }) => ($on ? "22px" : "2px")};
    width: 20px;
    height: 20px;
    border-radius: 9999px;
    background: #fff;
    box-shadow: 0 1px 3px rgba(10, 13, 18, 0.1),
      0 1px 2px -1px rgba(10, 13, 18, 0.1);
    transition: left 0.15s ease;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid #181d27;
    outline-offset: 2px;
  }
`;

const buttonBase = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 8px 14px;
  border-radius: 8px;
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const DarkButton = styled.button`
  ${buttonBase}
  border: 1px solid #181d27;
  background: #181d27;
  color: #fff;
`;

export const OutlineButton = styled.button`
  ${buttonBase}
  border: 0.909px solid rgba(0, 0, 0, 0.09);
  background: #fff;
  color: rgba(10, 13, 18, 0.7);
`;
